export default __webpack_public_path__ + "static/media/term.fa4d9b83.svg";